module.exports = __webpack_public_path__ + "img/arrow.c40624b1.svg";